import React, {useState, useEffect}from 'react'
import "./css/Rally.css"
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setRallyNumber,incrementRallyNumber,setQuestionAnswered,setBestRally} from "./redux/rallyTracker"
//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';
import { render } from '@testing-library/react';

const Rally = React.memo(props => {
     const [loading, setLoading] = useState(true);
     let dispatch = useDispatch();
     //redux
     const reduxRallyNumber = useSelector((state) => state.rallyTracker.reduxRallyNumber);
     const reduxBestRally = useSelector((state) => state.rallyTracker.reduxBestRally);
     //create the DB paths to put the data into


        var comment;
        if(reduxRallyNumber == 0){
          comment = "Get started";
        }
        else if(reduxRallyNumber == 1){
          comment = "Big Deal";
        }
        else if(reduxRallyNumber >= 2){
          comment = "in a row! ";
        }


      useEffect(() => {
        ////when you first sign up, the BEST rally # doesnt update on the first load. 
        ////hopefully this fixes things 
        if(reduxRallyNumber >= reduxBestRally){
          dispatch(setBestRally(reduxRallyNumber));
        }
      }, [])




     return (
          <div className='rallyContainer'>
              <div className='headerBar'>Your Best Rally</div>
              <div className='half'>
                  <p className={reduxRallyNumber === '' ? 'rallyNumber rallyLoading' : 'rallyNumber'}> 
                    {reduxRallyNumber} 
                  </p>
                  <p className='answers'>Current</p>
              </div>

              <div className='half' id='bestRally'>
                  <p className={reduxBestRally === '' ? 'rallyNumber rallyLoading' : 'rallyNumber'}> 
                    {/* {reduxBestRally == '' || reduxBestRally == null ? "0" : reduxBestRally}  */}
                    {reduxBestRally}
                  </p>
                  <p className='answers'>BEST</p>
              </div>


          </div>
     )
})

export default Rally
